import { render, staticRenderFns } from "./IconSend.vue?vue&type=template&id=a48414b6&scoped=true"
import script from "./IconSend.vue?vue&type=script&lang=js"
export * from "./IconSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48414b6",
  null
  
)

export default component.exports